import React, { useState } from "react";
import { Tag } from "antd";
import { Trans } from "@lingui/react/macro";

import colors from "../../styles/colors";
import { SeenFeatureService } from "../seen-features";

export function NewFeatureIndicator({
  featureId,
  showUntil,
  children,
}: React.PropsWithChildren<{ featureId: string; showUntil: Date }>) {
  const [seen, setSeen] = useState(() => SeenFeatureService.hasSeen(featureId));

  function markAsSeen() {
    SeenFeatureService.markAsSeen(featureId);
    setSeen(true);
  }

  if (seen || !SeenFeatureService.isStillAnnounced(showUntil)) {
    return <>{children}</>;
  }

  return (
    <span className="flex items-center gap-2" onClick={markAsSeen}>
      {children}
      <Tag variant="outlined" color={colors.green["500"]} className="!me-0 pointer-events-none">
        <Trans>new</Trans>
      </Tag>
    </span>
  );
}
